import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconVolume = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--volume")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M11.6492189,8 L16.375305,4.21913119 C17.0300683,3.69532051 18,4.16149379 18,5 L18,19 C18,19.8385062 17.0300683,20.3046795 16.375305,19.7808688 L11.6492189,16 L8,16 C7.44771525,16 7,15.5522847 7,15 L7,9 C7,8.44771525 7.44771525,8 8,8 L11.6492189,8 Z M16,7.08062485 L12.624695,9.78086881 C12.447382,9.92271925 12.2270715,10 12,10 L9,10 L9,14 L12,14 C12.2270715,14 12.447382,14.0772808 12.624695,14.2191312 L16,16.9193752 L16,7.08062485 Z" id="icon--centivo--volume"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1866.000000, -1312.000000)"/>
          <g id="Icon/volume">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--volume"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--volume"/>
          </g>
      </g>
  </IconWrapper>
)
